import React,{useContext} from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { ReactComponent as Processing } from "../../Assets/images/processing.svg";
import { ReactComponent as Pending } from "../../Assets/images/pending.svg";
import { ReactComponent as Paid2 } from "../../Assets/images/paid2.svg";
import { ReactComponent as Failed } from "../../Assets/images/failed.svg";
import { ReactComponent as Cancelled } from "../../Assets/images/cancelled.svg";
import StateContext from "../../StateContext";
function PaymentStatus({ invoiceable }) {
  const { t } = useTranslation();
  const appState = useContext(StateContext);

  return (
    <>
      {invoiceable.status === "Paid" || invoiceable.status === "Direct" ? (
        <div className="successIcon my-2 origin-center">
          <span className="px-2 origin-center">
            <Paid2 />
          </span>
          <div className="pt-2">
            <h4 className={`title ${appState.langValue == "ar" ? "text-right" : "text-left"
              }`}>{t("OrderStatus.Paid")}</h4>
            <p className="title-description">{t("OrderStatus.check-invoice-below")}</p>
          </div>
        </div>
      ) : invoiceable.status === "Pending" ? (
        <div className="successIcon my-2 origin-center">
          <Pending />
          <div>
            <h4 className={`title ${appState.langValue == "ar" ? "text-right" : "text-left"
              }`}>{t("invoice.pending")}</h4>
            <p className="title-description">{t("OrderStatus.check-invoice-below")}</p>
          </div>
        </div>
      ) : invoiceable.status === "Failed" ? (
        <div className="successIcon my-2  origin-center">
          <Failed />
          <div>
            <h4 className={`title ${appState.langValue == "ar" ? "text-right" : "text-left"
              }`}>Failed</h4>
            <p className="title-description">{t("OrderStatus.check-invoice-below")}</p>
          </div>
        </div>
      ) : invoiceable.status === "Cancelled" ? (
        <div className="successIcon my-2  origin-center">
          <Cancelled />
          <div>
            <h4 className={`title ${appState.langValue == "ar" ? "text-right" : "text-left"
              }`}>{t("invoice.Cancelled")}</h4>
            <p className="title-description">{t("OrderStatus.check-invoice-below")}</p>
          </div>
        </div>
      ) : (
        // if get abnormal behaviour
        <span>
          <div className="successIcon my-2  origin-center">
            <Cancelled />
            <div>
              <h4 className={`title ${appState.langValue == "ar" ? "text-right" : "text-left"
                }`}>Error 404</h4>
              <p className="title-description">Some thing is wrong!</p>
            </div>
          </div>
          <p className="title-error text-center">
            Please contact to waiter or support team.
          </p>
        </span>
      )}
    </>
  );
}

export default withTranslation()(PaymentStatus);
